/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const IbmWrapper = styled.span`
  font-family: "IBM Plex Sans Light", sans-serif;
  font-weight: 200;
`;

export const McaWrapper = styled.span`
  font-family: "IBM Plex Sans Medium", sans-serif;
  font-weight: ${theme.fontWeights.medium};
  > .abbreviated-name {
    display: none;
  }
  @media screen and (max-width: ${theme.breakpoints.xl}px) {
    > .full-name {
      display: none;
    }
    > .abbreviated-name {
      display: initial;
    }
  }
`;

export const LogoWrap = styled.div`
  flex: 1;

  @media screen and (min-width: ${theme.breakpoints.xl}px) {
    flex: 0;
    width: 13rem;
    margin-right: ${theme.spacing.spacing07};
  }
`;
